import React, { useState } from "react";
import classNames from 'classnames';

const SettingsTemplateProps = ({ value, onChange }) => {
  const properties = [
    {id: 'title', name: i18n.t('import_rss.props.title')},
    {id: 'link', name: i18n.t('import_rss.props.link')},
    {id: 'date', name: i18n.t('import_rss.props.date')},
    {id: 'description', name: i18n.t('import_rss.props.description')},
    {id: 'content', name: i18n.t('import_rss.props.content')},
    {id: 'image', name: i18n.t('import_rss.props.image')}
  ];

  const [checked, setChecked] = useState(value || properties.map(i => i.id));

  const handleChange = (id) => {
    const newChecked = checked.includes(id) ? checked.filter(i => i !== id) : checked.concat(id);
    setChecked(newChecked);
    onChange(newChecked);
  }

  const button = ({id, name}, i) => {
    const buttonClasses = classNames(
      'btn', 'btn-form',
      {
        '': value === id
      }
    );
    return <div key={i} className="checkbox checkbox-primary">
        <input
          type="checkbox"
          checked={checked.includes(id)}
          className="btn btn-primary"
          id={id}
          onChange={() => handleChange(id)}
        />
        <label htmlFor={id}>
          <span>{name}</span>
        </label>
      </div>;
  }

  return (
    <div className="btn-group">
      {properties.map(button)}
    </div>
  );
};

export default SettingsTemplateProps;
